import { cn } from "@/lib/utils";
import { useNavigationBarStore } from "@/lib/zustand";
import { useEffect } from "react";
import { Link } from "react-router-dom";

type Page = {
    title: string;
} & ({
    goTo: string;
} | {
    onClick: () => void;
})

export interface BackNavProps {
    currentPageName: string;
    pages?: Page[],
    className?: string;
}

export function BackNav({
    currentPageName,
    pages,
    className = ''
}: BackNavProps) {
    return (
        <div className={cn("flex pb-3 items-center", className)} style={{ maxWidth: 1200 }}>
            {pages?.map((page) => (
                <div className="flex items-center p-0 m-0 pe-2" key={page.title}>
                    {(() => {
                        if ('onClick' in page) {
                            return (
                                <button onClick={page.onClick} className="p-0 m-0 border-0" style={{ background: 'transparent' }}>
                                    <p className="flex items-center p-0 m-0 text-xs font-bold capitalize text-slate-400">
                                        {page.title}
                                    </p>
                                </button>
                            )
                        } else {
                            return (
                                <Link to={page.goTo} className="p-0 m-0 text-xs font-bold capitalize text-slate-400 h-min" style={{ background: 'transparent' }}>
                                    {page.title}
                                </Link>
                            )
                        }
                    })()}
                    <i className="bi bi-chevron-right ps-2" style={{ fontSize: ".65rem" }}></i>
                </div>
            ))
            }

            {currentPageName && (
                <div className="flex items-center p-0 m-0">
                    <button disabled className="p-0 m-0 border-0" style={{ background: 'transparent' }}>
                        <p className="flex items-center p-0 m-0 text-xs font-bold capitalize text-slate-800">
                            {currentPageName}
                        </p>
                    </button>
                </div>
            )}
        </div>
    )
}

function NavigationBarBreadCrumbs() {
    const { breadCrumbs } = useNavigationBarStore();
    return (
        <div className={cn("flex items-center")} style={{ maxWidth: 1200 }}>
            {breadCrumbs?.pages?.map((page) => (
                <div className="flex items-center p-0 m-0 pe-2" key={page.title}>
                    {(() => {
                        if ('onClick' in page) {
                            return (
                                <button onClick={page.onClick} className="p-0 m-0 border-0" style={{ background: 'transparent' }}>
                                    <p className="flex items-center p-0 m-0 text-xs font-bold capitalize text-white/80">
                                        {page.title}
                                    </p>
                                </button>
                            )
                        } else {
                            return (
                                <Link to={page.goTo} className="p-0 m-0 text-xs font-bold capitalize text-slate-400 h-min" style={{ background: 'transparent' }}>
                                    {page.title}
                                </Link>
                            )
                        }
                    })()}
                    <i className="bi bi-chevron-right ps-2" style={{ fontSize: ".65rem" }}></i>
                </div>
            ))
            }

            {breadCrumbs?.currentPageName && (
                <div className="flex items-center p-0 m-0">
                    <button disabled className="p-0 m-0 border-0" style={{ background: 'transparent' }}>
                        <p className="flex items-center p-0 m-0 text-xs font-bold text-white capitalize">
                            {breadCrumbs.currentPageName}
                        </p>
                    </button>
                </div>
            )}
        </div>
    )
}

function Set({
    currentPageName,
    pages,
}: BackNavProps) {
    const { setBreadCrumbs } = useNavigationBarStore();
    useEffect(() => {
        setBreadCrumbs({
            currentPageName,
            pages
        });
    }, [currentPageName, pages, setBreadCrumbs]);
    return <></>
}

NavigationBarBreadCrumbs.Set = Set;

export {NavigationBarBreadCrumbs}